module.exports = __webpack_public_path__ + "media/fyt_m21.f07ff7fa.mp4";